// Utility to trim transparent padding from a canvas (used by StyleIcon).
export function trimCanvas(canvas: HTMLCanvasElement): HTMLCanvasElement {
  const ctx = canvas.getContext("2d");
  if (!ctx) return canvas;

  const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const len = pixels.data.length;
  const bound = { top: canvas.height, left: canvas.width, right: 0, bottom: 0 };

  for (let i = 0; i < len; i += 4) {
    if (pixels.data[i + 3] === 0) continue; // Skip fully transparent pixels

    const idx = i / 4;
    const x = idx % canvas.width;
    const y = Math.floor(idx / canvas.width);

    if (x < bound.left) bound.left = x;
    if (x > bound.right) bound.right = x;
    if (y < bound.top) bound.top = y;
    if (y > bound.bottom) bound.bottom = y;
  }

  const trimHeight = bound.bottom - bound.top + 1;
  const trimWidth = bound.right - bound.left + 1;

  if (trimWidth <= 0 || trimHeight <= 0) return canvas;

  const trimmed = ctx.getImageData(bound.left, bound.top, trimWidth, trimHeight);
  canvas.width = trimWidth;
  canvas.height = trimHeight;
  ctx.putImageData(trimmed, 0, 0);

  return canvas;
}
